import React from 'react'

import { connect } from 'react-redux'
import { reduxForm, startSubmit } from 'redux-form'
import { appDeleteRequest } from '../../actions'

import { Form, FormSection, FormError } from 'components/Form'
import { ConfirmDeleteButton } from 'components/Button'

import { appDeleteValidator } from './validators.js'
import FieldSection from './FieldSection.js'
import { TEXT } from './fieldTypes.js'

const DeleteAppForm = props => {
	const { dispatchSubmit, handleSubmit, submitting, dirty, error } = props

	const fields = [
		{
			type: TEXT,
			name: 'delete',
			fieldId: 'delete',
			title: 'Write DELETE to confirm you want to delete this app',
			description:
				'Once you delete the app, there is no going back. Please be certain.',
			validate: appDeleteValidator,
			autofocus: true
		}
	]

	return (
		<Form handleSubmit={handleSubmit(dispatchSubmit)}>
			{fields.map(field => {
				return <FieldSection {...field} key={field.fieldId} />
			})}
			<FormSection right>
				{!submitting ? <FormError error={error} /> : null}
				<ConfirmDeleteButton submitting={submitting} dirty={dirty} />
			</FormSection>
		</Form>
	)
}

const mapDispatchToProps = (dispatch, ownProps) => {
	return {
		dispatchSubmit: values => {
			dispatch(startSubmit('deleteAppForm'))
			dispatch(
				appDeleteRequest({
					id: ownProps.appId,
					formName: 'deleteAppForm',
					...values
				})
			)
		}
	}
}

const ConnectedDeleteAppForm = connect(null, mapDispatchToProps)(
	reduxForm({
		form: 'deleteAppForm',
		touchOnBlur: false,
		enableReinitialize: true
	})(DeleteAppForm)
)

export default ConnectedDeleteAppForm



// WEBPACK FOOTER //
// ./src/containers/Forms/DeleteAppForm.js